export const baseURL = "https://dev-reports.ordrmtv.com/api/salesdata"
